import events from "../../events/EventsObservable";

import ReelSpinnerData from "./ReelSpinnerData";
import {REELS_EVENTS} from "./reelsEvents";
import Reel from "./Reel";
import ReelPrinter from "./ReelPrinter";
import ReelsConfig from "./ReelsConfig";

const states = {
    "idle": 0,
    "delay": 1,
    "accUpStart": 2,
    "accUp": 3,
    "accDownStart": 4,
    "accDown": 5,
    "spin": 6,
    "prestopping": 7,
    "stopping": 8,
    "brakeDownStart": 9,
    "brakeDown": 10,
    "brakeUpStart": 11,
    "brakeUp": 12,
    "stop": 13
};

class ReelSpinner {

    protected _shiftY: number = 0;
    protected _reel: Reel;
    protected _printer: ReelPrinter;
    protected _state: number;
    protected _speed: number = 0;

    protected _symbolsLeftToStop: number;
    protected _symbolsLeftToStopping: number;
    protected _symbolsLeftToStoppingDelay: number;

    protected _requestStop: boolean = false;
    protected _isForcestop: boolean = false;
    protected _forceStopping: boolean = false;

    protected _reelOrder: number;
    protected _cfg: any;

    protected _symbolRealHeight: number;

    protected _spinResolver: ()=>any;

    protected _data: ReelSpinnerData;

    constructor (reel: Reel, printer: ReelPrinter, reelsConfig: ReelsConfig) {

        this._reel = reel;

        this._printer = printer;

        this._state = states["idle"];

        this._reelOrder = this._reel.id + 1;

        this._cfg = {};
        this._cfg.symbolHeight = reelsConfig.getSymbolHeight();
        this._cfg.symbolOffsetY = reelsConfig.getSymbolOffsetY();

        this._symbolRealHeight = this._cfg.symbolHeight + this._cfg.symbolOffsetY;

        this._cfg.spinDuration = reelsConfig.getSpinDuration();
        this._cfg.commonSpeed = reelsConfig.getSpinCommonSpeed(); //symbols per sec
        this._cfg.delayBtwReelStarts = reelsConfig.getDelayBtwReelStarts(); //in sec
        this._cfg.delayBtwReelStops = reelsConfig.getDelayBtwReelStops(); //in symbols count

        this._cfg.accHeight = reelsConfig.getAccHeight(); // * (this._cfg.symbolHeight + this._cfg.symbolOffsetY);
        this._cfg.accMoveTime = reelsConfig.getAccMoveTime() * 1000;
        this._cfg.accMoveBackTime = reelsConfig.getAccMoveBackTime() * 1000;

        this._cfg.brakeHeight = reelsConfig.getBrakeHeight();
        this._cfg.brakeMoveTime = reelsConfig.getBrakeMoveTime() * 1000;
        this._cfg.brakeMoveBackTime = reelsConfig.getBrakeMoveBackTime() * 1000;

        this._data = new ReelSpinnerData(this, reel);
    }

    reinit () {
        this._requestStop = false;
        this._symbolsLeftToStop = this._reel.getSymbols().length - 1;
        this.reinitSymbolsToStopping();
    }

    reinitSymbolsToStopping() {
        this._symbolsLeftToStopping = this._cfg.spinDuration;
        this._symbolsLeftToStoppingDelay = this._cfg.delayBtwReelStops * this._reelOrder;
    }

    /**
     * @return {Reel}
     */
    getReel() {
        return this._reel;
    }

    getSymbolsLeftToStoppingDelay(): number {
        return this._symbolsLeftToStoppingDelay;
    }

    /**
     * @param {number} count
     */
    setSymbolsToStoppingDelay(count) {
        this._symbolsLeftToStoppingDelay = count;
    }

    getSpinDuration() {
        return this._cfg.spinDuration;
    }

    getDelayBtwReelStops() {
        return this._cfg.delayBtwReelStops;
    }

    tick (delta) {
        this._move(this._speed * (delta / 1000), delta);
    }

    isForceStopping() {
        return this._forceStopping;
    }

    isRunning () {
        return this._state !== states["idle"];
    }

    start() {
        return new Promise<void>(res => {

            this._isForcestop = false;
            this._forceStopping = false;

            this.reinit();
            // this._reel.getResSymbols().length = 0;

//            if(this._state !== states["idle"]) {
//                res();
//                return;
//            }

            this._state = states["delay"];

            let startDelay = this._cfg.delayBtwReelStarts * this._reelOrder;
            if(startDelay) {
                setTimeout(() => { this._state = states["accUpStart"]; }, startDelay * 1000);
            } else {
                this._state = states["accUpStart"];
            }

            this._spinResolver = res;
        });
    }

    stop () {
        this._requestStop = true;
    };

    forcestop() {
        this._isForcestop = true;
    }

    getForceStop() {
        return this._isForcestop;
    }

    speedTo(symbolsPerSec, duration = 200) {
        let speed = this._calcSpinSpeed(symbolsPerSec);
        createjs.Tween.get(this, { override: true }).to({ _speed: speed }, duration);
    }

    _calcSpinSpeed(symbolsPerSec) {
        return (this._symbolRealHeight) * symbolsPerSec;
    }

    _move (shift, delta) {

        if(this._state === states["idle"]) {
            return;
        }

        switch(this._state) {

            case states["accUpStart"]:

                this._shiftY = 0;
                this._data.shift = 0;

                if(!this._cfg.accMoveTime) {
                    this._state = states["accDown"];
                    events.dispatchSync(REELS_EVENTS.REEL_ACC_DOWN, this._data);
                    this.tick(delta);
                    return;
                }


                this._state = states["accUp"];
                this._speed = (this._cfg.symbolHeight * this._cfg.accHeight) * (1000 / this._cfg.accMoveTime);


                events.dispatchSync(REELS_EVENTS.REEL_ACC_UP, this._data);
                this.tick(delta);

                break;

            case states["accUp"]:

                if(this._shiftY <= -(this._cfg.symbolHeight * this._cfg.accHeight)) {
                    this._state = states["accDown"];
                    events.dispatchSync(REELS_EVENTS.REEL_ACC_DOWN, this._data);
                    this.tick(delta);
                    return;
                }

                this._shiftY -= shift;

                this._data.shift = -shift;
                events.dispatchSync(REELS_EVENTS.REEL_MOVE, this._data);

                this._printer.print(this._reel, this._shiftY);
                return;

            case states["accDown"]:

                if(this._shiftY >= 0) {
                    this._shiftY = 0;

                    this._data.shift = 0;
                    events.dispatchSync(REELS_EVENTS.REEL_SPIN, this._data);

                    this._state = states["spin"];

                    this._speed = this._calcSpinSpeed(this._cfg.commonSpeed);
                    this.tick(delta);
                    return;
                }

                this._shiftY += shift;

                this._data.shift = shift;
                events.dispatchSync(REELS_EVENTS.REEL_MOVE, this._data);

                this._printer.print(this._reel, this._shiftY);

                return;

            case states["spin"]:

                if(this._canStop()) {
                    this._state = states["stopping"];

                    this._data.shift = 0;
                    events.dispatchSync(REELS_EVENTS.REEL_STOPPING, this._data);

                    this.tick(delta);
                    return;
                }

                this._shiftY += shift;

                this._data.shift = shift;
                events.dispatchSync(REELS_EVENTS.REEL_MOVE, this._data);

                this._watchSymbols(delta);
                this._printer.print(this._reel, this._shiftY);
                return;

            case states["stopping"]:

                this._shiftY += shift;

                this._data.shift = shift;
                events.dispatchSync(REELS_EVENTS.REEL_MOVE, this._data);

                this._watchSymbols(delta);
                this._printer.print(this._reel, this._shiftY);
                return;

            case states["brakeDownStart"]:

                this._shiftY = 0;
                this._data.shift = 0;
                this._state = states["brakeDown"];

                createjs.Tween.removeTweens(this);

                if(!this._cfg.brakeMoveTime) {
                    this._state = states["brakeUp"];
                    events.dispatchSync(REELS_EVENTS.REEL_BRAKEUP, this._data);
                    this.tick(delta);
                    return;
                }

                this._speed = (this._cfg.symbolHeight * this._cfg.brakeHeight) * (1000 / this._cfg.brakeMoveTime);

                events.dispatchSync(REELS_EVENTS.REEL_BRAKEDOWN, this._data);

                this.tick(delta);
                break;

            case states["brakeDown"]:

                this._shiftY += shift;

                if(this._shiftY >= (this._cfg.symbolHeight * this._cfg.brakeHeight)) {
                    this._state = states["brakeUp"];
                    events.dispatchSync(REELS_EVENTS.REEL_BRAKEUP, this._data);
                    this.tick(delta);
                    return;
                }

                this._data.shift = shift;
                events.dispatchSync(REELS_EVENTS.REEL_MOVE, this._data);

                this._printer.print(this._reel, this._shiftY);
                break;

            case states["brakeUp"]:

                if(this._shiftY <= 0 || !this._cfg.brakeMoveBackTime) {
                    this._state = states["stop"];
                    //this.tick(delta);
                    return;
                }

                this._shiftY -= shift;

                this._data.shift = -shift;
                events.dispatchSync(REELS_EVENTS.REEL_MOVE, this._data);


                this._printer.print(this._reel, this._shiftY);
                break;

            case states["stop"]:

                this._data.shift = 0;
                events.dispatchSync(REELS_EVENTS.REEL_MOVE, this._data);

                this._shiftY = 0;
                this._state = states["idle"];
                this._printer.print(this._reel, 0);

                events.dispatchSync(REELS_EVENTS.REEL_STOP, this._data);

                this._spinResolver && this._spinResolver();
                this._forceStopping = false;

                break;

        }
    }

    _canStop () {

        if(!this._requestStop || !this._reel.getResSymbols().length) {
            return false;
        }

        if(this._isForcestop) {
            this._forceStopping = true;
            this._isForcestop = false;
            return true;
        }

        return this._symbolsLeftToStopping + this._symbolsLeftToStoppingDelay <= 0;
    }

    _watchSymbols (delta) {

        while(this._shiftY > this._symbolRealHeight) {
            this._shiftY -= this._symbolRealHeight;

            if(this._state === states["stopping"]) {
                if(this._watchStop(delta)) {
                    return;
                }
            }

            if(this._state === states["spin"]) {
                this._watchStopping();
            }
        }
    }

    _watchStopping () {
        this._reel.spinNextSymbol();

        if(this._symbolsLeftToStopping > 0) {
            this._symbolsLeftToStopping--;
        }

        if(!this._symbolsLeftToStopping && this._reel.getResSymbols().length) {
            this._symbolsLeftToStoppingDelay--;
        }
    }

    _watchStop (delta) {

        this._symbolsLeftToStop--;

        if(this._symbolsLeftToStop <= 0) {
            this._reel.spinNextSymbol();

            this._state = states["brakeDownStart"];
            this._shiftY = 0;
            this.tick(delta);
            return true;
        }

        this._reel.spinNextResSymbol(this._symbolsLeftToStop - 1);

        return false;
    }
}

export default ReelSpinner;
